import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { StateManagementService } from "../../../providers/state-management/state-management.service";

/**
 * Generated class for the WongBakerToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "wong-baker-tool",
  templateUrl: "wong-baker-tool.html",
})
export class WongBakerToolComponent {
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();
  @Input() readonly: boolean = false;
  options: object[] = [];
  currentValue: number;

  constructor(
    public translatePipe: TranslateService,
    public stateData: StateManagementService
  ) {
    // console.log('Hello WongBakerToolComponent Component');
    // console.log('I needed some bread, but I went to the Wong-Baker!');

    let options = this.options;

    options.push({
      img: "assets/img/wong-baker/0.png",
      value: 0,
      description: "wongBaker0Desc",
    });

    options.push({
      img: "assets/img/wong-baker/2.png",
      value: 2,
      description: "wongBaker2Desc",
    });

    options.push({
      img: "assets/img/wong-baker/4.png",
      value: 4,
      description: "wongBaker4Desc",
    });

    options.push({
      img: "assets/img/wong-baker/6.png",
      value: 6,
      description: "wongBaker6Desc",
    });

    options.push({
      img: "assets/img/wong-baker/8.png",
      value: 8,
      description: "wongBaker8Desc",
    });

    options.push({
      img: "assets/img/wong-baker/10.png",
      value: 10,
      description: "wongBaker10Desc",
    });

    // console.log( "WB Options: ", this.options );

    if (this.existingData) {
      this.currentValue = this.existingData["value"]["wongBaker"];
    }
  }

  optionClicked(value: number) {
    if (this.readonly) {
      return;
    }

    this.currentValue = value;
    this.stateData.setMyData(this.currentValue);

    this.onValueUpdate.emit({
      severity: value,
      values: {
        wongBaker: value,
      },
    });
  }

  @Input() set existingData(data: object) {
    // console.log( "Setting new WONG-BAKER form value: ", data );
    if (data && data["tool"] === "wongBaker" && data["values"]) {
      this.currentValue = data["values"]["wongBaker"];
    }
    // console.log( "New WONG-BAKER form value: ", this.currentValue );
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/wong-baker-tool/wong-baker-tool.ts